import React from 'react'
import NextImage, { StaticImageData } from 'next/image'
import { EmtTypography } from 'emt-components-v2'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { HomeBottomCard, NewsCardButton } from './StyledComponents'
import NextALink from '../NextALink'

type Props = {
  image: StaticImageData
  title: string
  button: string
  href: string
  buttonColor?: string
}

const BottomCard: React.FC<Props> = ({ image, title, button, href, buttonColor = 'primary' }) => {
  return (
    <Grid item xs={12} md={6} lg={4}>
      <HomeBottomCard elevation={0}>
        <Box>
          <NextImage src={image} quality={100} alt={title} />
        </Box>
        <Box className="emtPaper-home-card-innerContent">
          <EmtTypography variant="body1" fontWeight="bold">
            {title}
          </EmtTypography>
          <NextALink href={href}>
            <NewsCardButton variant="outlined" size="small" color={buttonColor} sx={{ textDecoration: 'none' }}>
              {button}
            </NewsCardButton>
          </NextALink>
        </Box>
      </HomeBottomCard>
    </Grid>
  )
}

export default BottomCard
